import mitraOne from "../../../public/static/images/png/mitra/mitra-1.jpeg";
import mitraTwo from "../../../public/static/images/png/mitra/mitra-2.png";
import firstPartner from "../../../public/static/images/svg/mitra/1.svg";
import secondPartner from "../../../public/static/images/svg/mitra/2.svg";
import thirdPartner from "../../../public/static/images/svg/mitra/3.svg";
import fourthPartner from "../../../public/static/images/svg/mitra/4.svg";
import fifthPartner from "../../../public/static/images/svg/mitra/5.svg";

export const item = [
  {
    img: mitraOne,
    title: "Director - Deputy CEO of Erajaya Active Lifestyle",
    message:
      "“Dengan Home Credit, lebih banyak konsumen kami yang bisa terbantu saat membeli produk-produk yang mereka butuhkan”",
    name: "Andre Tan",
  },
  {
    img: mitraTwo,
    title: "Deputy of CMO of BliBli",
    message:
      "“Kami senang dapat bermitra dengan Home Credit. Karena dapat mempermudah pelanggan kami untuk mendapatkan kebutuhan yang diinginkan.”",
    name: "Andy Adrian",
  },
];

export const itemManfaat = [
  {
    title: "Jangkau Lebih Banyak Pelanggan",
    subtitle:
      "Ingin mengembangkan usaha? Sales Associate kami selalu siap membantu mempromosikan bisnis dan produk Anda!"
  },
  {
    title: "Bikin Pembiayaan Transaksi Jadi Mudah",
    subtitle:
      "Sales Associate kami sigap memandu proses pengajuan pembiayaan transaksi pelanggan Anda. Dijamin antiribet!"
  },
  {
    title: "Pembiayaan Cepat dan Terpercaya",
    subtitle:
      "Selain tangkas dalam memproses pengajuan pembiayaan, kami juga cekatan memastikan pembayarannya sampai ke toko Anda."
  }
];

export const howToArray = [
  {
    img: firstPartner,
    heading: "Lengkapi formulir aplikasi online",
  },
  {
    img: secondPartner,
    heading:
      "Sampaikan pada kami waktu yang nyaman bagi Kamu untuk bertemu District Sales Manager kami",
  },
  {
    img: thirdPartner,
    heading:
      "Izinkan District Sales Manager kami menyimpan informasi dan dokumen bisnis Kamu",
  },
  {
    img: fourthPartner,
    heading: "Kami akan melakukan beberapa pemeriksaan",
  },
  {
    img: fifthPartner,
    heading: "Setelah semua selesai, kerjasama bisnis kita dapat dimulai",
  },
];

export const listPartnerDesktop = [
  {
    name: "partner-home-desktop-1.png",
    description: null,
    url: "/static/images/png/mitra/partner-home-desktop-1.png",
  },

  {
    name: "partner-home-desktop-2.png",
    description: null,
    url: "/static/images/png/mitra/partner-home-desktop-2.png",
  },
];

export const listPartnerMobile = [
  {
    name: "partner-home-mobile-1.png",
    description: null,
    url: "/static/images/png/mitra/partner-home-mobile-1.png",
  },

  {
    name: "partner-home-mobile-2.png",
    description: null,
    url: "/static/images/png/mitra/partner-home-mobile-2.png",
  },
];
